import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  createResolution,
  deleteResolutionById,
  updateResolutionById,
} from '../thunks/resolutions';

const resolutionsAdapter = createEntityAdapter();
const resolutionsSlice = createSlice({
  name: 'resolutions',
  initialState: resolutionsAdapter.getInitialState({}),
  reducers: {
    setResolutions: (state, action) => {
      resolutionsAdapter.upsertMany(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createResolution.fulfilled, (state, action) => {
        resolutionsAdapter.upsertOne(state, action.payload);
      })
      .addCase(deleteResolutionById.fulfilled, (state, action) => {
        resolutionsAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateResolutionById.fulfilled, (state, action) => {
        const { id } = action.payload;
        resolutionsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      });
  },
});

export const { setResolutions } = resolutionsSlice.actions;

export const resolutionsAdapterSelectors = resolutionsAdapter.getSelectors(
  (state) => state.resolutions
);

export default resolutionsSlice.reducer;
